import { render, staticRenderFns } from "./DictItemEdit.vue?vue&type=template&id=23893203&scoped=true"
import script from "./DictItemEdit.vue?vue&type=script&lang=js"
export * from "./DictItemEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23893203",
  null
  
)

export default component.exports